<template>
        
    <div>
        <div v-if="!empty" class="order-list">
            <div class="cart__order" v-for="(item, index) in store.items" >
                <div class="cart__order--left">
                    <div class="cart__order--img">
                        <a v-bind:href="item.link">
                            <div v-bind:style="{ backgroundImage: 'url(\'' + getItemThumb(item) + '\')' }" style="background-size: cover;"></div>
                        </a>
                    </div>
                    <div class="cart__order--heading">
                        <input type="hidden" v-bind:name="'product[' + index + '][id]'" v-bind:value="item.id">
                        
                        <a v-bind:href="item.link">
                            <h4>{{ item.title }}</h4>                  
                        </a>
                        <div class="product__price"><span>Цена:</span>{{ getItemPrice(item) | format_money }} лв.</div>
                    </div>
                </div>
                <div class="cart__order--delete" v-on:click.prevent="remove(index)">
                    <span class="icon-error"></span>
                </div>
                <span class="cart__order--error" v-show="item.error" v-html="item.error"></span>
            </div>

            <div class="cart__delivary">
                <div class="cart__delivary--left">
                <p>Доставка: <span>{{ totalDeliveryPrice | format_money }} лв</span></p>
                <p>Отстъпка: <span>{{ discountAmount | format_money }} лв</span></p>
                </div>
                <div class="cart__delivary--right">
                    Общо: <span class="product__price">{{ totalPrice | format_money }} лв</span>
                </div>
                
            </div>
        </div>
        <div v-else class="no-products">
            Няма продукти в количката.
        </div>
    </div>
</template>

<script>

	export default {

        props: [
            "deliveryPrice",
            "freeShippingThreshold",
            "cashOnDeliveryTax",
            "checkPromoCodeUrl",
            "oldPromoCode",
            "errors"
        ],

        data() {
            return {
                store: CartItems,
                promoCodeDiscount: 0,
                promoCodeType: '',
                promoCodeReq: null,
                localErrors: []
            };
        },

        computed: {

            empty() {
                return this.store.empty();
            },

            totalPrice() {

                return this.totalProductsPrice ? this.totalProductsPrice + this.totalDeliveryPrice - this.discountAmount : 0;

            },

            discountAmount() {

                if (this.totalProductsPrice) {
                    if (this.promoCodeType == "sum") {
                        return this.promoCodeDiscount;

                    } else if (this.promoCodeType == "percent") {
                        return this.totalProductsPrice * this.promoCodeDiscount / 100;
                        
                    }
                }

                return 0;

            },

            totalProductsPrice() {

                var price = 0;
                var items = this.store.items;
                
                for (var i = 0, len = items.length; i < len; i++) {
                    price += this.getItemPrice(items[i]);
                }

                return price;

            },


            totalDeliveryPrice() {
                if (typeof this.store.delivery.price === "undefined") {
                    return 0;
                }

                if (this.store.delivery.price == 0 || this.store.delivery.price === null) {
                    return 0;
                }

                if (this.store.delivery.freeShippingThreshold) {
                    var productsPrice = this.totalProductsPrice;

                    if (productsPrice > this.store.delivery.freeShippingThreshold) {
                        return 0;
                    }
                }

                if (this.store.paymentMethod == "cash_on_delivery" && this.cashOnDeliveryTax) {
                    return parseFloat(this.store.delivery.price, 10) + this.totalProductsPrice * parseFloat(this.cashOnDeliveryTax, 10) / 100;
                }

                return parseFloat(this.store.delivery.price, 10);

            },


        },

        methods: {

            remove(index) {
                this.store.remove(index);
            },

            getItemPrice(item) {
                var price = item.promo_price ? parseFloat(item.promo_price, 10) : parseFloat(item.price, 10);

                for (var i = 0, len = item.selectedOptions.length; i < len; i++) {
                    price += parseFloat(item.selectedOptions[i].price, 10);
                }

                return price;
            },

            getItemThumb(item) {

                for (var i = 0; i < item.attachments.length; i++) {
                    if (item.attachments[i].key == "thumb") {
                        return item.attachments[i].path;
                    }
                }

                return null;

            },

            getSelectedOptionTitles: function(item) {

                var result = [];

                for (var i = 0, len = item.selectedOptions.length; i < len; i++) {
                    result.push(item.selectedOptions[i].title);
                }

                return result.join(", ");

            },

            checkPromoCode: function(jqEl) {

		   		if (this.promoCodeReq) {
					this.promoCodeReq.abort();
				}

                var _this = this;
                var promoCode = jqEl.parent().find("input[name='promo_code']").val();
                var promoCodeMessage = jqEl.closest(".form__group").find(".promo-code-message");

                this.promoCodeReq = $.ajax({
                    cache: false,
					url: _this.checkPromoCodeUrl + "?code=" + promoCode,
					method: 'get',
					beforeSend: function() {
						jqEl.addClass("btn--loading")
							.attr("disabled", true)
							.prop("disabled", true);
					},
					success: function(response) {
                        if (typeof response === "string") {
                            promoCodeMessage.text(response).parent().removeClass("hidden");

                            _this.promoCodeDiscount = 0;
                            _this.promoCodeType = '';
			        	} else {
                            promoCodeMessage.text(response.message).parent().removeClass("hidden");
                            
                            _this.promoCodeDiscount = parseFloat(response.discount);
                            _this.promoCodeType = response.discount_type;
			        	}
					},
					error: function(jqXhr) {
						var status = jqXhr.status;
						var response = jqXhr.responseText;
            
                        promoCodeMessage.parent().addClass("hidden");

						if (status == 500) {
							alert("Грешка на сървъра");
						}
						else {
							alert("Грешка");
						}
					},
					complete: function() {
						setTimeout(function() {
							jqEl.removeClass("btn--loading")
								.removeProp("disabled")
								.removeAttr("disabled");
						}, 500);
					}
				});
            }

        },

        watch: {

            totalPrice: function(newValue) {
                this.$emit("change-total-price", newValue);
            }

        },

        mounted() {
            var _this = this;
            this.localErrors = JSON.parse(this.errors);
            this.store.items = this.store.items.map(function(item, index) {
                if (_this.localErrors["product." + index]) {
                    item.error = _this.localErrors["product." + index][0];
                    return item;
                } else {
                    item.error = false;
                    return item;
                }
            });

            $("#check-promo-code-btn").on("click", function(e) {
                e.preventDefault();
                _this.checkPromoCode($(this));                
            });

            if (this.oldPromoCode) {
                $("#check-promo-code-btn").trigger("click");
            }
            
            // On component mounted
            this.$emit("change-total-price", this.totalPrice);

        }

    }
</script>